// Frontend display metadata only.
// Runtime feature enforcement always comes from subscription.limits returned by the backend.
//
// Important:
// - "pro" remains a display alias for historical Legacy Pro records.
// - New public purchases use "pro_2026".
// - Agency capacity is represented by agency_6 / agency_15 / agency_25 / agency_50.
export const NUDGE_PLANS = {
  free: {
    label: 'Free',
    mailboxes: 1,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 500,
    followUpCreditsMonthly: 100,
    historicalLookbackDays: 30,
    removeBranding: false,
  },

  early_access: {
    label: 'Early access',
    mailboxes: 1,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 500,
    followUpCreditsMonthly: 100,
    historicalLookbackDays: 30,
    removeBranding: false,
  },

  legacy_pro: {
    label: 'Pro',
    monthlyPrice: 12,
    annualPrice: 96,
    grandfathered: true,
    mailboxes: 3,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 5000,
    followUpCreditsMonthly: 1000,
    historicalLookbackDays: 180,
    maxFollowUps: 7,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
  },

  // Older stored planId="pro" is intentionally Legacy Pro.
  pro: {
    label: 'Pro',
    monthlyPrice: 12,
    annualPrice: 96,
    grandfathered: true,
    mailboxes: 3,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 5000,
    followUpCreditsMonthly: 1000,
    historicalLookbackDays: 180,
    maxFollowUps: 7,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
  },

  pro_ph_trial: {
    label: 'Product Hunt Pro',
    monthlyPrice: 12,
    annualPrice: 96,
    grandfathered: true,
    mailboxes: 3,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 5000,
    followUpCreditsMonthly: 1000,
    historicalLookbackDays: 180,
    maxFollowUps: 7,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
  },

  // Current public subscription plans.
  pro_2026: {
    label: 'Pro',
    monthlyPrice: 39,
    annualPrice: 390,
    purchasable: true,
    mailboxes: 3,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    opportunityScansMonthly: 6000,
    followUpCreditsMonthly: 1000,
    historicalLookbackDays: 180,
    maxFollowUps: 5,
    autoCreateDrafts: true,
    includeThreadAttachments: false,
    customInstructions: true,
    autoSend: false,
    customCadence: false,
    timezoneAwareSendWindows: false,
    researchAndDraft: false,
  },

  agency_6: {
    label: 'Agency 6',
    monthlyPrice: 99,
    annualPrice: 990,
    purchasable: true,
    mailboxes: 6,
    workspaces: 3,
    teamMembers: 3,
    teamManagement: true,
    opportunityScansMonthly: 20000,
    followUpCreditsMonthly: 3000,
    historicalLookbackDays: 365,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
    researchAndDraft: true,
  },

  agency_15: {
    label: 'Agency 15',
    monthlyPrice: 199,
    annualPrice: 1990,
    purchasable: true,
    mailboxes: 15,
    workspaces: 5,
    teamMembers: 5,
    teamManagement: true,
    opportunityScansMonthly: 50000,
    followUpCreditsMonthly: 5000,
    historicalLookbackDays: 730,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
    researchAndDraft: true,
  },

  agency_25: {
    label: 'Agency 25',
    monthlyPrice: 299,
    annualPrice: 2990,
    purchasable: true,
    mailboxes: 25,
    workspaces: 10,
    teamMembers: 10,
    teamManagement: true,
    opportunityScansMonthly: 80000,
    followUpCreditsMonthly: 8000,
    historicalLookbackDays: 1095,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
    researchAndDraft: true,
  },

  agency_50: {
    label: 'Agency 50',
    monthlyPrice: 499,
    annualPrice: 4990,
    purchasable: true,
    mailboxes: 50,
    workspaces: 1000000,
    teamMembers: 1000000,
    unlimitedWorkspaces: true,
    unlimitedTeamMembers: true,
    teamManagement: true,
    opportunityScansMonthly: 120000,
    followUpCreditsMonthly: 12000,
    historicalLookbackDays: 1460,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    autoCreateDrafts: true,
    includeThreadAttachments: true,
    customInstructions: true,
    autoSend: true,
    customCadence: true,
    timezoneAwareSendWindows: true,
    researchAndDraft: true,
  },

  // AppSumo display metadata. Backend remains the source of truth for enforcement.
  appsumo_tier_1: {
    label: 'AppSumo Tier 1',
    lifetimePrice: 49,
    mailboxes: 1,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    followUpCreditsMonthly: 250,
    historicalLookbackDays: 90,
    maxFollowUps: 3,
  },

  appsumo_tier_2: {
    label: 'AppSumo Tier 2',
    lifetimePrice: 109,
    mailboxes: 3,
    workspaces: 1,
    teamMembers: 1,
    teamManagement: false,
    followUpCreditsMonthly: 1000,
    historicalLookbackDays: 180,
    maxFollowUps: 5,
  },

  appsumo_tier_3: {
    label: 'AppSumo Tier 3',
    lifetimePrice: 179,
    recommended: true,
    mailboxes: 6,
    workspaces: 3,
    teamMembers: 3,
    teamManagement: true,
    followUpCreditsMonthly: 3000,
    historicalLookbackDays: 365,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
  },

  appsumo_tier_4: {
    label: 'AppSumo Tier 4',
    lifetimePrice: 299,
    mailboxes: 15,
    workspaces: 5,
    teamMembers: 5,
    teamManagement: true,
    followUpCreditsMonthly: 5000,
    historicalLookbackDays: 730,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    researchAndDraft: true,
  },

  appsumo_tier_5: {
    label: 'AppSumo Tier 5',
    lifetimePrice: 589,
    mailboxes: 50,
    workspaces: 1000000,
    teamMembers: 1000000,
    unlimitedWorkspaces: true,
    unlimitedTeamMembers: true,
    teamManagement: true,
    followUpCreditsMonthly: 12000,
    historicalLookbackDays: 1460,
    maxFollowUps: 25,
    allowContinueUntilReply: true,
    researchAndDraft: true,
  },
};

export const PUBLIC_PURCHASABLE_PLAN_IDS = [
  'pro_2026',
  'agency_6',
  'agency_15',
  'agency_25',
  'agency_50',
];

export const AGENCY_PLAN_IDS = [
  'agency_6',
  'agency_15',
  'agency_25',
  'agency_50',
];

export function normalizeFrontendPlanId(planId = '') {
  const clean = String(planId || '').trim().toLowerCase().replace(/-/g, '_');

  if (['pro', 'paid', 'stripe_pro'].includes(clean)) return 'legacy_pro';
  if (['agency', 'agency6'].includes(clean)) return 'agency_6';

  return clean || 'free';
}

export function formatLimit(value) {
  if (value === null || value === undefined) return '—';

  const numeric = Number(value || 0);
  if (numeric >= 1000000) return 'Unlimited';

  return new Intl.NumberFormat().format(numeric);
}

